/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DiscountStatus {
  ACTIVE = 'active',
  NOT_ACTIVE = 'not_active',
}
